.mainContentSection {
  background-color: white;
}

.contentSection {
  width: 100%;
  max-width: 900px;
  font-size: 18px;
}

.heading {
  font-size: 32px;
  color: #3caeb0;
  font-weight: bold;
  line-height: 1.1em;
  margin-bottom: 20px;
}

.subsectionHeading {
  color: #3caeb0;
  font-size: 32px;
  line-height: 1.1em;
  font-weight: 700;
  margin-top: 30px;
  margin-bottom: 15px;
}

.subheading {
  color: #3caeb0;
  font-size: 24px;
  line-height: 1.1em;
  font-weight: 600;
  margin-bottom: 10px;
  margin-top: 20px;
}

.paragraph {
  margin-bottom: 4px;
  font-size: 18px;
}

.content {
  line-height: 1.55em;
  letter-spacing: normal;
  text-wrap: pretty;
}

.form {
  padding: 48px 0;
}

.imageSection {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 5px 20px;
  background-color: white;
}

.contentImage {
  width: 100%;
  max-width: 1024px;
  height: auto;
  display: block;
}

.benefitsList {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.benefitItem {
  margin-bottom: 4px;
  align-items: flex-start;
  font-size: 18px;
}

.benefitItem .rt-Text {
  font-size: 18px;
}

.bulletPoint {
  color: #3caeb0;
  font-weight: bold;
  margin-right: 8px;
  margin-top: 2px;
}

.benefitDescription {
  color: #666;
  margin-top: 4px;
  font-style: italic;
}

@media (min-width: 768px) {
  .heading {
    font-size: 50px;
  }

  .subsectionHeading {
    font-size: 35px;
  }

  .subheading {
    font-size: 24px;
  }

  .form {
    padding: 96px 20px;
  }

  .imageSection {
    padding: 60px 20px;
  }
}
